// https://vuex.vuejs.org/en/getters.html

export default {
  orgId: state => {
    return state[state.email].Org.id
  },
  orgName: state => {
    return state[state.email].Org.name
  },
  userName: state => {
    const { firstName, lastName } = state[state.email].Profile
    return `${firstName} ${lastName}`
  }
}
